import {sendPostRequest, sendPatchRequest, sendDeleteRequest, sendGetRequest, sendPutRequest} from "@/helper/requests";
import viewer from "@/urls/roles/viewer";
import {executeRequest} from "@/store/utils";

const state = {
    fields:{
        currentUrl: null,
        items: [],
        loading: false,
        count: 0,
        error: null
    }
}

const getters = {
    getFieldsList: state => state.fields.items,
    getFieldsCount: state => state.fields.count,
    getFieldsCurrentUrl: state => state.fields.currentUrl,
    isLoadingFields: state => state.fields.loading,
    saveFieldsError: state => state.fields.error
}

const actions = {
    loadFieldsList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) {
            url = viewer.VIEWER.FIELDS.LIST()
            if (urlAppend) url = urlAppend(url)
        }
        if (!getters.isLoadingFields){
            commit("SET_FIELDS_LOADING");
            sendGetRequest(
                url, (data, url) => {
                    commit("SET_FIELDS_LIST", data["results"]);
                    commit("SET_FIELDS_COUNT", data["count"]);
                    commit("SET_FIELDS_CURRENT_URL", url);
                    commit("SET_FIELDS_LOADING_END");
                    finalizer(data, url);
                }, (data, url) => {
                    commit("SET_FIELDS_LOADING_END");
                    commit("SAVE_FIELDS_ERROR", data);
                    catcher(data, url);
                }
            )
        }
    }
}

const mutations = {
    SET_FIELDS_LIST: (state, fields) => {
        state.fields.items = fields
    },
    SET_FIELDS_COUNT: (state, value) => {
        state.fields.count = value
    },
    SET_FIELDS_CURRENT_URL: (state, value) => {
        state.fields.currentUrl = value
    },
    SET_FIELDS_LOADING: (state) => {
        state.fields.loading = true
    },
    SET_FIELDS_LOADING_END: (state) => {
        state.fields.loading = false
    },
    SAVE_FIELDS_ERROR: (state, error) => {
        state.fields.error = error
    }
}

export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters
}
